<template>
  <el-dialog title="Reservar Imóvel" @open="reset" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="30%" v-loading="isLoading">
    <el-form ref="form" :model="reserva" :rules="validacao" size="small" label-position="top" hide-required-asterisk :show-message="false">
      <el-row :gutter="10">
        <el-col :span="16">
          <el-form-item label="Cliente" style="width: 100%" prop="cliente">
            <el-select v-model="reserva.cliente"
              :remote-method="recuperarClientesSelect"
              :loading="loadingClientes"
              value-key="id"
              placeholder=""
              loading-text="Carregando clientes"
              no-data-text="Nenhum cliente encontrado"
              filterable
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in clientesDisponiveis"
                :key="item.id"
                :label="formatarSelectCliente(item)"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="Duração">
            <el-select v-model="reserva.duracao" style="width: 100%">
              <el-option
                v-for="item in duracaoReserva"
                :key="item.data"
                :label="item.label"
                :value="item.data">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Usuário" style="width: 100%" prop="usuarioReserva">
            <el-select v-model="reserva.usuarioReserva"
              :remote-method="recuperarUsuariosSelect"
              :loading="loadingUsuarios"
              value-key="id"
              placeholder=""
              loading-text="Carregando usuários"
              no-data-text="Nenhum usuário encontrado"
              filterable
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in usuariosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="gravar" type="success" size="small" round class="btn-box-shadow">Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';

import funcoes from '../../../util/funcoes.js';
import URLS from '../../../util/urls.js';
import { DURACAO_RESERVA } from '../../../util/constantes.js';

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      loadingClientes: false,
      loadingUsuarios: false,
      clientesDisponiveis: [],
      usuariosDisponiveis: [],

      reserva: {
        duracao: 24,
        cliente: { id: 0 }
      },

      validacao: {
        cliente: [{ required: true, validator: this.validarCliente }],
      }
    }
  },
  computed: {
    ...mapState('alugueisImoveisStore', {
      imovel(state) { return state.imovelSelecionado },
    }),
    ...mapState({
      isLoading(state) { return state.loading },
    }),
    duracaoReserva() { return DURACAO_RESERVA }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),

    ...mapActions('loginStore', [
      'relogar',
    ]),

    ...mapActions('alugueisImoveisStore', [
      'reservarImovel'
    ]),

    validarCliente(rule, value, callback) {
      if(this.reserva.cliente.id != 0) {
        return callback();
      } else {
        return callback(new Error());
      }
    },
    
    reset() {
      this.reserva = {
        duracao: 24,
        cliente: { id: 0 },
        usuarioReserva: { id: 0 }
      }
      this.clientesDisponiveis = [];
      this.usuariosDisponiveis = [];
    },
    gravar() {
      this.$refs["form"].validate(valid => {
        const formIsInvalid = !valid;
        if(formIsInvalid) {
          this.exibirAlert("Atenção", "Campo de cliente é obrigatório.");
          return;
        }
          let payload = this.reserva;
          payload.imovel = { id: this.imovel.id };

          this.showLoading();
          this.reservarImovel(payload)
          .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.concluir();
                break;
              case "FALHA":
                this.$message.warning(resultado.mensagem);
                break;
              case "ERRO":
                this.$message.error(resultado.mensagem);
                break;
            }
          }).catch(() => {
            this.hideLoading();
            this.$message.error("Não foi possível conectar-se com o servidor");
          });
      });
    },

    recuperarClientesSelect(queryString) {
      let payload = {};

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString
      
      this.loadingClientes = true;

      axios.post(URLS.CLIENTES_LISTAR, payload)
      .then((response) => {
        if(response.data.status === 'SUCESSO') {
          this.clientesDisponiveis = response.data.lista;
        } else if(response.data.status === 'SESSAO_EXPIRADA') {
          this.relogar().then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              this.recuperarClientesSelect(queryString);
            }
          });
        }
      }).catch(() => {
        this.clientesDisponiveis = [];
      }).finally(() => {
        this.loadingClientes = false;
      });
    },

    recuperarUsuariosSelect(queryString) {
      let payload = { nome: queryString }
      this.loadingUsuarios = true;

      axios.post(URLS.USUARIOS_LISTAR, payload)
      .then((response) => {
        if(response.data.status === 'SUCESSO') {
          this.usuariosDisponiveis = response.data.lista;
        } else if(response.data.status === 'SESSAO_EXPIRADA') {
          this.relogar().then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              this.recuperarUsuariosSelect(queryString);
            }
          });
        }
      }).catch(() => {
        this.usuariosDisponiveis = [];
      }).finally(() => {
        this.loadingUsuarios = false;
      });
    },
    
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },

    formatarSelectCliente(cliente){
      return funcoes.formatarSelectCliente(cliente);
    },
    concluir() {
      this.$emit('reservar');
    },
    fechar() {
      this.$emit('close');
    }
  }
}
</script>

